"use strict";

/**
|--------------------------------------------------
| Datepicker
|--------------------------------------------------
*/

import { Datepicker } from 'vanillajs-datepicker';
export const initDatepicker = (selector) => {
    const inputs = document.querySelectorAll(selector);
    inputs.forEach(input => {
        new Datepicker(input, {
            buttonClass: 'btn',
            format: 'dd/mm/yyyy',
            weekStart: 1,
            autohide: true
        });
    });
};